import React from "react";
import RelativeTime from "components/common/RelativeTime";
const IndexRangeSummary = ({ indexRange }) => {
  if (!indexRange) {
    return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("i", null, "No index range available."));
  }
  return /* @__PURE__ */ React.createElement("span", null, "Range re-calculated ", /* @__PURE__ */ React.createElement(RelativeTime, { dateTime: indexRange.calculated_at }), " in ", indexRange.took_ms, "ms.");
};
export default IndexRangeSummary;
